import Svg, { ClipPath, Defs, G, Path } from 'react-native-svg'

export const Arrow = (props: any) => {
  return (
    <Svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" {...props}>
      <Defs>
        <ClipPath id="prefix__a">
          <path transform="translate(655 136)" fill="#fff" d="M0 0h24v24H0z" />
        </ClipPath>
      </Defs>
      <G clipPath="url(#prefix__a)" transform="translate(-655 -136)">
        <Path d="M653.901 141.74l17.817-10.286 10.286 17.816-17.816 10.287z" fill="none" />
        <Path d="M665.394 157.468l11.723-15.677-19.438 2.314 2.992 5.2 11.993-4.943-10.279 7.913z" fill="#0070b6" />
      </G>
    </Svg>
  )
}
